import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

export default function Layout() {
  const location = useLocation();
  const [isPageVisible, setIsPageVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Start transition
    setIsTransitioning(true);
    setIsPageVisible(false);
    
    // Quick scroll to top without smooth (prevents janky animation)
    window.scrollTo({ top: 0, behavior: 'auto' });
    
    // Short delay then show new page with animation
    const showTimer = setTimeout(() => {
      setIsPageVisible(true);
      setIsTransitioning(false);
    }, 100);
    
    return () => clearTimeout(showTimer);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      
      {/* Page transition overlay */}
      <div 
        className={`fixed inset-0 z-40 bg-background/80 backdrop-blur-sm pointer-events-none transition-opacity duration-200 ${
          isTransitioning ? 'opacity-100' : 'opacity-0'
        }`}
      />
      
      <main 
        className={`flex-1 transition-all duration-400 ease-out ${
          isPageVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-2'
        }`}
      >
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
